
'use client';
import { useState, useEffect } from 'react';

interface TimeLeft {
    days: number
    hours: number
    minutes: number
    seconds: number
}

export default function CountdownTimer() {
    const [timeLeft, setTimeLeft] = useState<TimeLeft>({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    })
    const [isClient, setIsClient] = useState(false)

    useEffect(() => {
        setIsClient(true)
    }, [])

    useEffect(() => {
        if (!isClient) return

        const calculateTimeLeft = (): TimeLeft => {
            const valentinesDay = new Date('2026-02-14T00:00:00')
            const now = new Date()
            const difference = valentinesDay.getTime() - now.getTime()

            if (difference > 0) {
                return {
                    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                    minutes: Math.floor((difference / 1000 / 60) % 60),
                    seconds: Math.floor((difference / 1000) % 60),
                }
            }

            return { days: 0, hours: 0, minutes: 0, seconds: 0 }
        }

        setTimeLeft(calculateTimeLeft())

        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft())
        }, 1000)

        return () => clearInterval(timer)
    }, [isClient])

    if (!isClient) {
        return (
            <div data-component-id="src/app/homepage/components/CountdownTimer.tsx:56:12" data-component-path="src/app/homepage/components/CountdownTimer.tsx" data-component-line="56" data-component-end-line="63" data-component-file="CountdownTimer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-4%20gap-4%22%7D" className="grid grid-cols-4 gap-4">
                {[0, 0, 0, 0].map((_, i) => (
                    <div data-component-id="src/app/homepage/components/CountdownTimer.tsx:58:20" data-component-path="src/app/homepage/components/CountdownTimer.tsx" data-component-line="58" data-component-end-line="61" data-component-file="CountdownTimer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22glass-card%20p-6%20text-center%22%7D" key={`placeholder_${i}`} className="glass-card p-6 text-center">
                        <div data-component-id="src/app/homepage/components/CountdownTimer.tsx:59:24" data-component-path="src/app/homepage/components/CountdownTimer.tsx" data-component-line="59" data-component-end-line="59" data-component-file="CountdownTimer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-5xl%20font-bold%20text-white%20mb-2%22%2C%22textContent%22%3A%2200%22%7D" className="text-5xl font-bold text-white mb-2">00</div>
                        <div data-component-id="src/app/homepage/components/CountdownTimer.tsx:60:24" data-component-path="src/app/homepage/components/CountdownTimer.tsx" data-component-line="60" data-component-end-line="60" data-component-file="CountdownTimer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-xs%20uppercase%20tracking-widest%20text-white%2F60%22%2C%22textContent%22%3A%22Loading%22%7D" className="text-xs uppercase tracking-widest text-white/60">Loading</div>
                    </div>
                ))}
            </div>
        )
    }

    const timeUnits = [
        { value: timeLeft.days, label: 'Days' },
        { value: timeLeft.hours, label: 'Hours' },
        { value: timeLeft.minutes, label: 'Minutes' },
        { value: timeLeft.seconds, label: 'Seconds' },
    ]

    return (
        <div data-component-id="src/app/homepage/components/CountdownTimer.tsx:75:8" data-component-path="src/app/homepage/components/CountdownTimer.tsx" data-component-line="75" data-component-end-line="92" data-component-file="CountdownTimer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20md%3Agrid-cols-4%20gap-6%22%7D" className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {timeUnits.map((unit, index) => (
                <div data-component-id="src/app/homepage/components/CountdownTimer.tsx:77:16" data-component-path="src/app/homepage/components/CountdownTimer.tsx" data-component-line="77" data-component-end-line="90" data-component-file="CountdownTimer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22glass-card%20p-6%20text-center%20backdrop-blur-xl%20border%20border-white%2F10%20hover%3Aborder-primary%2F50%20transition-all%20duration-500%20group%20relative%20overflow-hidden%22%7D"
                    key={unit.label}
                    className="glass-card p-6 text-center backdrop-blur-xl border border-white/10 hover:border-primary/50 transition-all duration-500 group relative overflow-hidden"
                >
                    <div data-component-id="src/app/homepage/components/CountdownTimer.tsx:81:20" data-component-path="src/app/homepage/components/CountdownTimer.tsx" data-component-line="81" data-component-end-line="81" data-component-file="CountdownTimer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20bg-primary%2F5%20opacity-0%20group-hover%3Aopacity-100%20transition-opacity%20duration-500%22%7D" className="absolute inset-0 bg-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                    <div data-component-id="src/app/homepage/components/CountdownTimer.tsx:82:20" data-component-path="src/app/homepage/components/CountdownTimer.tsx" data-component-line="82" data-component-end-line="89" data-component-file="CountdownTimer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20z-10%22%7D" className="relative z-10">
                        <div data-component-id="src/app/homepage/components/CountdownTimer.tsx:83:24" data-component-path="src/app/homepage/components/CountdownTimer.tsx" data-component-line="83" data-component-end-line="85" data-component-file="CountdownTimer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-5xl%20md%3Atext-7xl%20font-serif%20font-bold%20text-gradient-valentine%20mb-2%20tabular-nums%20tracking-tight%22%7D" className="text-5xl md:text-7xl font-serif font-bold text-gradient-valentine mb-2 tabular-nums tracking-tight">
                            {String(unit.value).padStart(2, '0')}
                        </div>
                        <div data-component-id="src/app/homepage/components/CountdownTimer.tsx:86:24" data-component-path="src/app/homepage/components/CountdownTimer.tsx" data-component-line="86" data-component-end-line="88" data-component-file="CountdownTimer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-xs%20uppercase%20tracking-%5B0.2em%5D%20text-white%2F50%20font-medium%20group-hover%3Atext-primary%2F80%20transition-colors%22%7D" className="text-xs uppercase tracking-[0.2em] text-white/50 font-medium group-hover:text-primary/80 transition-colors">
                            {unit.label}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}